import {Base} from '../../common/model/base.model';
import {GeoProvincia} from './geo-provincia.model';
import {GeoNazione} from '../geonazione/geo-nazione.model';

export class GeoComune extends Base {

  constructor(protected id: number,
              public denominazione: string,
              public codiceIstat: string,
              public provincia: GeoProvincia,
              public nazione: GeoNazione
  ) {
    super(id);
  }

  public getLabel() {
    return this.denominazione + this.provincia.getLabel();
  }

}
